import * as getters from "../getters";

export function modifyPagination(container, instance) {
    if (!$(container).find('[name="start"]').length) {
        let text = Translator.__('Strona');

        $(container).find('.pagination-element').append(`
            <div class="form-group bg-white">
                <input type="number" min="1" value="${instance.page.info().page + 1}" name="start" class="form-control form-control-sm" placeholder="${text}">
            </div>
        `);
    }
    return true;
}

/**
 * Dodaje możliwość zmieniania strony po upłynięciu 500ms po ostatnim wpisaniu w polu
 */
export function paginationTimeout() {
    let inputPaginationTimeout = null;

    $('body').on('input', '[name="start"]', e => {
        const currentTable = getters.getCurrentTableInstance(e.target);

        clearTimeout(inputPaginationTimeout);

        inputPaginationTimeout = setTimeout(function () {
            if ((e.target.value - 1) >= 0) {
                currentTable.page(e.target.value - 1).draw('page');
            }
        }, 500);
    });
}
